import React, { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { PageHero, Section, DataTable, EmptyState, Badge } from "@/components/premium/UI";
import { Pattern } from "@/components/premium/Patterns";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/audit-logs?limit=500").then(r => setLogs(r.data || [])).catch(() => setLogs([])).finally(() => setLoading(false));
  }, []);
  return (
    <div className="space-y-6" data-testid="audit-page">
      <PageHero
        eyebrow="Security"
        title="Audit log"
        subtitle="Every state-changing action across Home360, chronologically. Visible only to administrators and executive roles."
        moduleKind="dashboard"
      />
      <Section className="relative overflow-hidden">
        <Pattern kind="dashboard" />
        <div className="relative">
          {loading ? <div className="animate-pulse space-y-2">{[1,2,3,4,5].map(i => <div key={i} className="h-8 bg-muted/40 rounded" />)}</div>
          : logs.length === 0 ? <EmptyState icon={ShieldCheck} title="No audit events" description="Actions across Home360 will appear here." />
          : (
            <DataTable
              testid="audit-table"
              columns={[
                { header: "When", cell: r => r.timestamp?.slice(0, 19).replace("T", " ") },
                { header: "User", cell: r => <span className="font-medium">{r.user_username || r.user_email || "—"}</span> },
                { header: "Action", cell: r => <Badge variant="primary">{r.action}</Badge> },
                { header: "Resource", key: "resource" },
                { header: "Category", cell: r => r.category ? <Badge variant="neutral">{r.category}</Badge> : "—" },
                { header: "Reference", key: "resource_id" },
              ]}
              rows={logs}
            />
          )}
        </div>
      </Section>
    </div>
  );
}
